import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const InvalidFormAlert = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        icon: "info",
        message: getLabel('products.contactLens.info.invalidMessage')
    });
};

export { InvalidFormAlert };
//# sourceMappingURL=InvalidFormAlert.js.map
